import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useMemo } from "react";
import { TFunction } from "i18next";
import { getValidationSchema } from "./form-page-validations/form-page-validation";
import { useBoundInput } from "src/hooks/use-bound-input";
import { withoutRef } from "src/components/address-section/helper";
import type { FormData } from "./form-page";

export const useFormPageSetup = (t: TFunction) => {
    const validationSchema = useMemo(() => getValidationSchema(t), [t]);

    const methods = useForm<FormData>({
        defaultValues: {
            firstName: "",
            lastName: "",
            email: "",
            dobDay: "",
            dobMonth: "",
            dobYear: "",
            income: "",
            currentAddress: {
                flatNumber: "",
                houseNumber: "",
                houseName: "",
                street: "",
                townCity: "",
                county: "",
                postcode: "",
                month: "",
                year: "",
            },
            previousAddress: {
                flatNumber: "",
                houseNumber: "",
                houseName: "",
                street: "",
                townCity: "",
                county: "",
                postcode: "",
                month: "",
                year: "",
            },
        },
        resolver: yupResolver(validationSchema),
        mode: "onBlur",
        reValidateMode: "onChange",
    });

    const { errors } = methods.formState;

    const firstNameProps = useBoundInput({ name: "firstName", control: methods.control });
    const lastNameProps = useBoundInput({ name: "lastName", control: methods.control });
    const emailProps = useBoundInput({ name: "email", control: methods.control });
    const incomeProps = withoutRef(useBoundInput({ name: "income", control: methods.control }));

    return {
        methods,
        errors,
        firstNameProps,
        lastNameProps,
        emailProps,
        incomeProps,
    };
};
